import { BASE_URL } from "./appConst";
import { axiosAuth } from "./common"
import { EditSchemaFormData } from "src/schemas/edit-trainee";
import { formatDate } from "src/utils";

export const getTrainees = async({currentPageNumber, pageSize, queryString}) => {

  const api = axiosAuth();

  const response = await api.get(`${BASE_URL}/trainings?page=${currentPageNumber}&pagesize=${pageSize}&${queryString}`);

  return response.data;
}

export const editTrainee = async (id: number, values: EditSchemaFormData) => {
  const api = axiosAuth();

  const response = await api.patch(`${BASE_URL}/edit-training/${id}`, {
    full_name: values.full_name,
    email: values.email,
    phone_no: values.phone_number,
    whatsapp_no: values.whatsapp_number,
    date_of_birth: values.date_of_birth,
    gender: values.gender,
    building_name: values.building_name,
    landmark: values.landmark,
    city: values.city,
    district: values.district,
    state: values.state,
    pin: values.postal_code,
    training_program: values.training_program,
    preferred_time: values.preferred_time,
    ...(values.preferred_training_date && {
      preferred_training_date: formatDate(values.preferred_training_date),
    }),
  });

  return response.data;
};
